export const ESTADOS_RESERVA = {
  ABANDONADA: 'ABANDONADA',
  BLOQUEADA: 'BLOQUEADA',
  RESERVADA: 'RESERVADA',
  PAGADA: 'PAGADA',
  CANCELADA: 'CANCELADA',
};

export const EstadosPagoReserva = {
  PAGOS_PENDIENTES: 'PAGOS_PENDIENTES',
  PAGOS_AL_DIA: 'PAGOS_AL_DIA',
  TOTALMENTE_PAGADA: 'TOTALMENTE_PAGADA',
  INSCRIPCION: 'INSCRIPCION',
};

export const ACCIONES_TARJETA_RESERVA = {
  CANCEL: 'Cancel',
  PAY: 'Pay',
  RECOVER: 'Recover',
};

export const TIPO_CODIGO_DESCUENTO = {
  PORCENTAJE: 'PORCENTAJE',
};

export const TIPO_TASA = {
  TASA_GESTION_CAMBIO: 'TASA_GESTION_CAMBIO',
  TASA_GESTION_PLATAFORMA: 'TASA_GESTION_PLATAFORMA',
  TASA_TURISTICA: 'TASA_TURISTICA',
};

export const TIPO_COMPLEMENTO = {
  PLAZAS_LIBRES: 'PLAZAS_LIBRES',
};
